import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { convertHexToRgba } from '@utils/cssHelpers'
import { RefObject, useEffect } from 'react'

/**
 * Implemented wth the intention that "harm" in performance
 * is minimum for the breakpoints not affected
 * It can be improved in the future
 *
 * Steps to use:
 * 1. const backgroundEl = useRef(null)
 * 2. useScrollOpacityChanger(backgroundEl.current)
 * 3. <BackgroundColorChangingDiv ref={backgroundEl} />
 */

/**
 *
 * @param el: the element to change opacity
 * @param breakpoint: the opacity change will only affect for equal or higher devices
 * @param changeSpeed: the higher this number, the faster the scroll transition
 */

const useScrollOpacityChanger = ({
  el,
  breakpoint = 0,
  changeSpeed = 2,
  bgColorChange = true
}: IUseScrollOpacityChanger) => {
  useEffect(() => {
    const handleScroll = () => {
      const opacityBgChanged = window.pageYOffset / (window.innerHeight / changeSpeed)
      const opacityChanged =
        (1 - (window.pageYOffset /
          (document.documentElement.scrollHeight - document.documentElement.clientHeight)) * changeSpeed)

      if (el.current) {
        if (bgColorChange) {
          el.current.style.backgroundColor = `rgba(${convertHexToRgba(tokens.color.light.base.neutrals[0].value)},${opacityBgChanged})`
        } else {
          el.current.style.opacity = opacityChanged.toString()
        }
      }
    }
    const handleResize = () => {
      if (window.innerWidth >= breakpoint) {
        window.addEventListener('scroll', handleScroll)
      } else {
        if (el.current) {
          if (bgColorChange) {
            el.current.style.backgroundColor = `rgba(${convertHexToRgba(tokens.color.light.base.neutrals[0].value, tokens.opacity[0].value)})`
          } else {
            el.current.style.opacity = tokens.opacity[0].value
          }
          window.removeEventListener('scroll', handleScroll)
        }
      }
    }
    /* Unfortunately, there is some mistery in the handling of REFs in React.
    The ref is not ready upfront (common problem as reported in StackOverflow).
    The problem here is more accusate because
    this is a reusable hook. Tried many things, and I had to fallback on this
    ugly timeout. If we had infinite time, I would keep investigating. Josep D */
    setTimeout(() => {
      if (el.current) {
        handleResize()
      }
    }, 500)
    window.addEventListener('resize', handleResize)

    return function () {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleResize)
    }
  }, [breakpoint, el, changeSpeed, bgColorChange])
}

interface IUseScrollOpacityChanger {
  el: RefObject<HTMLElement>,
  breakpoint?: number,
  changeSpeed?: number,
  bgColorChange?: boolean
}

export default useScrollOpacityChanger
